import { ValueType } from './types'

export const removeSpaces = (values: Record<string, ValueType>) => {
  const updatedValues = { ...values }
  Object.entries(updatedValues).forEach(([id, value]) => {
    updatedValues[id] = typeof value === 'string' ? value.trim() : value
  })
  return updatedValues
}
